import AccountingCoordinator from "../shared/documentInfrastructure/AccountingCoordinator.js";

/**
 * Model holding all the parts of a forecasting archive document, its
 * widgets and its state.  It handles communication between all of
 * these by registering to events and dispatching them via message
 * sends.
 */
export default class ForecastArchiveDocumentCoordinator extends AccountingCoordinator {
	_setupContentCallbacks() {
		return {
			getForecastUrl: this._getForecastViewerUrl.bind(this),
		};
	}

	_getForecastViewerUrl({ forecast }) {
		return this._router.linkTo("forecast-viewer/#forecastId", {
			forecastId: forecast.getId(),
		});
	}
}
